module.exports = __webpack_public_path__ + "static/sad-aymi-b983275e871487bd52bd9aea21217b4a.svg";